/* Purpose: This has any general static variables like max and min variables
 * Possible Exports: MAX_FILE_SIZE
 *                   statusColors
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/
export const MAX_FILE_SIZE = 15*1024*1024; //15MB;

export const statusColors = {"Intake": "light", "Processing": "secondary", "Underwriting": "info", "Approved": "success"}
